import jsSHA from 'jssha';

export default class SmsEcap {
  constructor(context) {
    this.elements = {
      overlay: context,
      html: document.documentElement,
    };
    this.init();
  }

  init() {
    this.ctaBtnEvtListeners();
  }

  ctaBtnEvtListeners() {
    const nextButtons = this.elements.overlay.querySelectorAll('.cta_positive');

    // Loop through all "Next" buttons and add a click event listener
    nextButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        // Find the closest parent step element
        const currentStep = button.closest('.steps--item');

        // Find the input within the current step
        const inputEl = currentStep.querySelector('.js-bfcm-input');

        // Only validate if an input exists on the current step
        if (inputEl) {
          this.validateInput(currentStep);
        } else {
          // If no input (like on the confirmation step), just go to the next step
          this.goToNextStep(currentStep);
        }
      });
    });
  }

  validateInput(currentEl) {
    const inputType = currentEl.querySelector('.js-bfcm-input').type;
    const inputEl = currentEl.querySelector(`.js-bfcm-input[type="${inputType}"]`);

    // Basic validation regex patterns
    const validationRegex = {
      tel: /^1? ?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    };

    const passedValidation = () => validationRegex[inputType].test(inputEl.value);

    if (passedValidation()) {
      let validValue = inputType === 'tel' ? parseInt(inputEl.value.replace(/\D/g, '')) : inputEl.value;

      // After validation, you will call the appropriate submission method.
      // We will then call goToNextStep inside those methods once the submission is successful.
      if (inputType === 'tel') {
        this.postScriptSubmit(validValue, currentEl);
      } else {
        currentEl.querySelector('form').classList.add('email-capture--loading');
        this.emailSubmit(validValue, currentEl);
      }
    } else {
      this.outputError(inputType, currentEl);
    }
  }

  outputError(inputType, currentEl) {
    // Clear any existing error states
    const allInputs = currentEl.querySelectorAll('.js-bfcm-input');
    allInputs.forEach((input) => input.classList.remove('error'));
    const allErrorLabels = currentEl.querySelectorAll('.email-input--message');
    allErrorLabels.forEach((label) => (label.ariaHidden = true));
    // depending on input type, add the appropriate text to error label
    let errorText = '';
    if (inputType == 'tel') {
      errorText = 'Enter a valid phone number';
    } else if (inputType == 'emailExists') {
      errorText = 'Oops! That email address is already in use.';
    } else {
      errorText = 'Enter a valid email address.';
    }
    const formEl = currentEl.querySelector('form'),
      inputEl = currentEl?.querySelector(`.js-bfcm-input[type="${inputType}"]`),
      errorLabel = formEl.querySelector('.input-message');
    inputEl?.classList.add('error');
    errorLabel.innerHTML = errorText;
    errorLabel.ariaHidden = false;
  }

  goToNextStep(currentStep) {
    const nextStep = currentStep.nextElementSibling;
    // Check if there is a next step
    if (nextStep && nextStep.classList.contains('steps--item')) {
      // Hide the current step
      currentStep.classList.remove('active');
      currentStep.style.display = 'none';

      // Show the next step
      nextStep.classList.add('active');
      nextStep.style.display = 'flex';

      // You can add more logic here, like focusing on the next input
      this.setTabNavBehavior(nextStep);
    }
  }

  postScriptSubmit(phoneNum, currentEl) {
    let url = 'https://api.postscript.io/api/subscriber/add',
      keyword = 'TXTBFCM',
      data = {
        phone: phoneNum,
        keyword: keyword,
      };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        authorization: 'd3f7002826826120fa2a1acec1ae9639',
      },
    })
      .then((res) => res.json())
      .then((response) => {
        // On success, go to the next step
        this.goToNextStep(currentEl);
      })
      .catch((error) => console.error('Error:', error));
  }

  emailSubmit(email, currentEl) {
    const form = currentEl.querySelector('form');
    const utmSrc = {};
    const signupSrc = 'EMBFCM';
    const props = { signup_source: signupSrc, ...utmSrc };
    const timeStamp = new Date();

    const payload = {
      '@type': 'contact',
      '@collection': signupSrc,
      email: email,
      '@merge': true,
      marketing_optin: 'EXPLICITLY_OPTEDIN',
      timestamp_subscribed: timeStamp.toISOString(),
      properties: props,
    };
    fetch(window.Brooklinen?.ometriaEndpoint, {
      method: 'POST',
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'X-Brooklinen-Auth': '0acf4539a14b3aa27deeb4cbdf6e989f',
        'content-type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        let shaObj = new jsSHA('SHA-256', 'TEXT');
        shaObj.update(email.toLowerCase());
        let emailHash = shaObj.getHash('HEX');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          submittedEmail: emailHash,
        });

        //Used for Ometria identify in GTM
        dataLayer.push({
          event: 'dl_subscribe',
          formLocation: 'bfcm_ecap',
        });
        const emailAlreadyExists = !(data?.ometria_contact === 'created' || (data?.ometria_contact_created && data?.shopify_contact_created));

        if (!emailAlreadyExists || !window?.Brooklinen?.ometriaErrorHandling) {
          try {
            heap.track('Email Optin', {
              email: email,
              signup_source: signupSrc,
            });
          } catch (e) {
            console.log(`Heap error ${e}`);
          }
          //formWrapper?.querySelector('.email-input')?.classList?.remove('error')

          this.goToNextStep(currentEl);
        } else {
          formWrapper.querySelector('.email-input').classList.add('error');
          this.outputError('emailExists', document.querySelector('#bfcm .steps-wrapper'));
        }
        form.classList.remove('email-capture--loading');
        return data;
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
